var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('b-row',[_c('b-modal',{attrs:{"id":"modal-1","title":"Formulario de tickets","size":"lg","hide-footer":""},on:{"hide":_vm.limpiarFormulario}},[_c('Tickets',{attrs:{"admin":true,"hideModal":_vm.limpiarFormulario}})],1),_c('b-col',{attrs:{"sm":_vm.cols}},[_c('ListTickets')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }